import { IWWPartners } from 'legacy/lut/classes/models/partner360/IWWPartners'
import { IComposedFilterForReport } from 'legacy/lut/features/partner360/composedReport'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

export const fetchPartnersFromGeneratedReport = async (
  filter: IComposedFilterForReport
): Promise<IWWPartners[]> => {
  const url = proxy(`/webservice/197/sp/v4/spJBPComposedReportScope/call`)
  const payload = {
    'p.Filters': JSON.stringify(filter),
  }
  const [accessToken] = getTokens()

  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }
  const response = await Rest.post({ url, payload, headers })
  return response?.Data || []
}
